/* BASE · comportamiento de las secciones bs-*.
   Los descuentos (2x, 3x, combo) son automáticos en Shopify: acá solo se agrega al carrito y se va a /cart. */
(function () {
  if (window.__bs) return;
  window.__bs = true;

  var cfg = window.BsConfig || {};
  var cartAddUrl = (cfg.cartAddUrl || '/cart/add') + '.js';
  var cartUrl = cfg.cartUrl || '/cart';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-AR');
  }
  function updatePay(root, total) {
    $$('[data-bs-pay]', root).forEach(function (el) {
      var t = parseFloat(el.getAttribute('data-transfer')) || 0;
      var n = parseInt(el.getAttribute('data-cuotas'), 10) || 0;
      var min = parseInt(el.getAttribute('data-min'), 10) || 0;
      var a = $('[data-bs-transfer]', el), c = $('[data-bs-cuota]', el);
      var yes = $('[data-bs-cuotas-yes]', el), no = $('[data-bs-cuotas-no]', el);
      var k = $('[data-bs-card]', el);
      if (k) k.textContent = money(total);
      if (a) a.textContent = money(total * (100 - t) / 100);
      if (c && n) c.textContent = money(total / n);
      var go = parseInt(el.getAttribute('data-go'), 10) || 0, g = $('[data-bs-go]', el);
      if (g && go) g.textContent = money(total / go);
      if (yes) yes.style.display = total >= min ? '' : 'none';
      if (no) no.style.display = total >= min ? 'none' : '';
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ── Agregar al carrito y redirigir ── */
  function addToCart(items, btn) {
    if (btn) { btn.classList.add('bs-busy'); btn.disabled = true; }
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { window.location.href = cartUrl; })
      .catch(function (err) {
        if (btn) { btn.classList.remove('bs-busy'); btn.disabled = false; }
        alert((err && (err.description || err.message)) || 'No pudimos agregar el producto. Probá de nuevo.');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bs-add]') : null;
    if (!t) return;
    e.preventDefault();
    var id = parseInt(t.getAttribute('data-variant'), 10);
    var qty = parseInt(t.getAttribute('data-qty') || '1', 10);
    if (id) addToCart([{ id: id, quantity: qty }], t);
  });

  /* ── Reveal al scrollear ── */
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('bs-on'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $$('[data-bs-reveal]').forEach(function (el) {
      if (el.getBoundingClientRect().top >= window.innerHeight * 0.85) { el.classList.add('bs-reveal'); io.observe(el); }
    });
  }

  /* ── Videos: reproducir solo cuando se ven ── */
  if ('IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.35 });
    $$('video[data-bs-auto]').forEach(function (v) { vio.observe(v); });
  }
  $$('.bs-reel video').forEach(function (v) {
    var box = v.parentNode;
    function mark() { box.classList.toggle('bs-paused', v.paused); }
    v.addEventListener('play', mark); v.addEventListener('pause', mark);
    box.addEventListener('click', function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
    mark();
  });

  /* ── Hero: slides con autoplay ── */
  $$('[data-bs-hero]').forEach(function (hero) {
    var track = $('.bs-hero-track', hero);
    var dots = $$('.bs-dots button', hero);
    var slides = $$('.bs-slide', hero);
    hero.classList.add('bs-js');
    if (slides[0]) slides[0].classList.add('bs-on');
    hero.style.setProperty('--bs-delay', (parseInt(hero.getAttribute('data-delay') || '0', 10) || 6) + 's');
    if (!track || dots.length < 2) return;
    var i = 0, timer = null;
    function go(n, smooth) {
      i = (n + dots.length) % dots.length;
      track.scrollTo({ left: track.clientWidth * i, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function mark() {
      var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      dots.forEach(function (d, k) { d.classList.toggle('bs-on', k === n); });
      slides.forEach(function (s, k) { s.classList.toggle('bs-on', k === n); });
      i = n;
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(mark); }, { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { stop(); go(k); }); });
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('mousedown', stop);
    var delay = parseInt(hero.getAttribute('data-delay') || '5', 10) * 1000;
    if (!reduced && delay > 0 && !(window.Shopify && Shopify.designMode)) timer = setInterval(function () { go(i + 1); }, delay);
  });

  /* ── Anuncios rotativos ── */
  $$('[data-bs-rot]').forEach(function (rot) {
    var items = $$('.bs-rot-view span', rot), i = 0, timer;
    if (items.length < 2) { $$('button', rot).forEach(function (b) { b.style.visibility = 'hidden'; }); return; }
    function go(n) { items[i].classList.remove('bs-on'); i = (n + items.length) % items.length; items[i].classList.add('bs-on'); }
    function play() { timer = setInterval(function () { go(i + 1); }, (parseInt(rot.getAttribute('data-delay'), 10) || 4) * 1000); }
    $('[data-prev]', rot).addEventListener('click', function () { clearInterval(timer); go(i - 1); play(); });
    $('[data-next]', rot).addEventListener('click', function () { clearInterval(timer); go(i + 1); play(); });
    if (!reduced) play();
  });

  /* ── Galería que se mueve sola: tocarla la frena un ratito y después sigue ── */
  $$('.bs-galm').forEach(function (gal) {
    var t;
    gal.addEventListener('click', function () {
      gal.classList.add('bs-galm--paused');
      clearTimeout(t);
      t = setTimeout(function () { gal.classList.remove('bs-galm--paused'); }, 3000);
    });
  });

  /* ── Menú mobile ── */
  var drawer = $('[data-bs-drawer]');
  if (drawer) {
    $$('[data-bs-menu-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.classList.add('bs-on'); }); });
    $$('[data-bs-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { drawer.classList.remove('bs-on'); }); });
  }

  /* ── Lightbox ── */
  var lb = $('[data-bs-lb]');
  if (lb) {
    var lbImg = $('img', lb);
    document.addEventListener('click', function (e) {
      var z = e.target.closest ? e.target.closest('[data-bs-zoom]') : null;
      if (z) { lbImg.src = z.getAttribute('data-bs-zoom') || z.currentSrc || z.src; lb.classList.add('bs-on'); return; }
      if (e.target === lb || (e.target.closest && e.target.closest('[data-bs-lb] button'))) lb.classList.remove('bs-on');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') lb.classList.remove('bs-on'); });
  }

  /* ── Reseñas: ver más ── */
  $$('[data-bs-rev-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = $('.bs-masonry', b.closest('.bs')); if (m) m.classList.add('bs-all');
      b.style.display = 'none';
    });
  });

  /* ── Popup de bienvenida ── */
  var pop = $('[data-bs-pop]');
  if (pop && !(window.Shopify && Shopify.designMode)) {
    var KEY = 'bs-welcome';
    var seen = false;
    try { seen = !!localStorage.getItem(KEY); } catch (err) {}
    var done = pop.hasAttribute('data-done');
    function closePop() { pop.classList.remove('bs-on'); try { localStorage.setItem(KEY, '1'); } catch (err) {} }
    if (done) { pop.classList.add('bs-on'); try { localStorage.setItem(KEY, '1'); } catch (err) {} }
    else if (!seen) setTimeout(function () { pop.classList.add('bs-on'); }, parseInt(pop.getAttribute('data-delay') || '6', 10) * 1000);
    $$('[data-bs-pop-close]', pop).forEach(function (b) { b.addEventListener('click', closePop); });
    pop.addEventListener('click', function (e) { if (e.target === pop) closePop(); });
  }

  /* ── PDP: variantes, packs por cantidad, galería, sticky ── */
  $$('[data-bs-pdp]').forEach(function (pdp) {
    var data;
    try { data = JSON.parse($('[data-bs-pdp-json]', pdp).textContent); } catch (err) { return; }
    var variants = data.variants || [];
    var current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];
    var qty = 1;
    var mainImg = $('[data-bs-main]', pdp);
    var gbadge = $('[data-bs-gbadge]', pdp);
    var atcs = $$('[data-bs-atc]', pdp.parentNode);
    var sticky = $('[data-bs-sticky]', pdp.parentNode);

    function setImage(src, thumb) {
      if (!mainImg || !src) return;
      if (!thumb) {
        var file = src.split('/').pop().split('?')[0];
        thumb = $$('.bs-thumb', pdp).filter(function (t) { return (t.getAttribute('data-full') || '').indexOf('/' + file) > -1; })[0] || null;
        if (thumb) src = thumb.getAttribute('data-full');
      }
      mainImg.src = src; mainImg.removeAttribute('srcset'); mainImg.setAttribute('data-bs-zoom', src);
      $$('.bs-thumb', pdp).forEach(function (t) { t.classList.toggle('bs-on', t === thumb); });
      if (thumb && thumb.parentNode.scrollTo) thumb.parentNode.scrollTo({ left: thumb.offsetLeft - 60, behavior: 'smooth' });
    }
    $$('.bs-thumb', pdp).forEach(function (t) {
      t.addEventListener('click', function () { setImage(t.getAttribute('data-full'), t); if (gbadge) gbadge.style.display = 'none'; });
    });

    function render() {
      if (!current) return;
      var base = current.compare_at_price && current.compare_at_price > current.price ? current.compare_at_price : current.price;
      $$('[data-bs-tier]', pdp).forEach(function (row) {
        var q = parseInt(row.getAttribute('data-qty'), 10);
        var off = parseFloat(row.getAttribute('data-off')) || 0;
        var price = current.price * q * (100 - off) / 100;
        var orig = base * q;
        var p = $('.p', row), w = $('.w', row), o = $('.o', row);
        if (p) p.textContent = money(price);
        if (w) { w.textContent = money(orig); w.style.display = orig > price ? '' : 'none'; }
        if (o) { var pct = Math.round((1 - price / orig) * 100); o.textContent = '-' + pct + '%'; o.style.display = pct > 0 ? '' : 'none'; }
        row.classList.toggle('bs-on', q === qty);
      });
      var sel = $('[data-bs-tier][data-qty="' + qty + '"]', pdp);
      var selOff = sel ? parseFloat(sel.getAttribute('data-off')) || 0 : 0;
      var total = current.price * qty * (100 - selOff) / 100;
      var now = $('[data-bs-now]', pdp), was = $('[data-bs-was]', pdp);
      if (now) now.textContent = money(current.price);
      if (was) { was.textContent = money(base); was.style.display = base > current.price ? '' : 'none'; }
      $$('[data-bs-total]', pdp.parentNode).forEach(function (el) { el.textContent = money(total); });
      updatePay(pdp, total);
      $$('[data-bs-vname]', pdp).forEach(function (el) { el.textContent = current.title; });
      atcs.forEach(function (b) {
        b.disabled = !current.available;
        var l = $('[data-bs-atc-label]', b);
        if (l) l.textContent = current.available ? (b.getAttribute('data-label') || 'Agregar al carrito') : 'Sin stock';
      });
    }

    $$('[data-bs-variant]', pdp).forEach(function (pill) {
      pill.addEventListener('click', function () {
        var id = parseInt(pill.getAttribute('data-bs-variant'), 10);
        current = variants.filter(function (v) { return v.id === id; })[0] || current;
        $$('[data-bs-variant]', pdp).forEach(function (p) { p.classList.toggle('bs-on', p === pill); });
        if (current.featured_image && current.featured_image.src) {
          setImage(current.featured_image.src, null);
          if (gbadge) { gbadge.textContent = current.title; gbadge.style.display = ''; }
        }
        try { var u = new URL(window.location.href); u.searchParams.set('variant', id); history.replaceState({}, '', u); } catch (err) {}
        render();
      });
    });
    $$('[data-bs-tier]', pdp).forEach(function (row) {
      row.addEventListener('click', function () { qty = parseInt(row.getAttribute('data-qty'), 10); render(); });
    });
    atcs.forEach(function (b) {
      b.addEventListener('click', function () { if (current && current.available) addToCart([{ id: current.id, quantity: qty }], b); });
    });
    if (sticky && 'IntersectionObserver' in window) {
      var anchor = $('[data-bs-atc]', pdp);
      if (anchor) new IntersectionObserver(function (en) {
        sticky.classList.toggle('bs-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(anchor);
    }
    render();
  });

  /* ── Carrito: cambiar cantidad / quitar ── */
  $$('[data-bs-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var cart = b.closest('[data-bs-cart]');
      if (cart) cart.classList.add('bs-busy');
      fetch((cfg.cartChangeUrl || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-q'), 10) || 0 })
      }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
    });
  });

  /* ── Entrega estimada: días hábiles desde hoy ── */
  $$('[data-bs-delivery]').forEach(function (el) {
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function biz(n) { var d = new Date(), a = 0; while (a < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) a++; } return d; }
    function fmt(d) { return dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()]; }
    var f = $('[data-from]', el), t = $('[data-to]', el);
    if (f) f.textContent = fmt(biz(parseInt(el.getAttribute('data-from'), 10) || 3));
    if (t) t.textContent = fmt(biz(parseInt(el.getAttribute('data-to'), 10) || 7));
  });

  /* ── Notificaciones de compra: recorre las compras cargadas en la sección, sin inventar nada ── */
  $$('[data-bs-notif]').forEach(function (box) {
    var list;
    try { list = JSON.parse($('[data-list]', box).textContent); } catch (err) { return; }
    if (!list || !list.length || (window.Shopify && Shopify.designMode)) return;
    list = list.slice().sort(function () { return Math.random() - 0.5; });
    var i = 0, stopped = false;
    var every = (parseInt(box.getAttribute('data-every'), 10) || 30) * 1000;
    function hide() { box.classList.remove('bs-on'); }
    function show() {
      if (stopped) return;
      var n = list[i % list.length]; i++;
      $('[data-title]', box).textContent = n.name + (n.place ? ' de ' + n.place : '');
      $('[data-sub]', box).textContent = 'compró ' + n.product;
      $('[data-when]', box).textContent = n.when ? n.when + ' · ' : '';
      var img = $('[data-img]', box); if (n.img) { img.src = n.img; img.alt = n.product; }
      $('[data-link]', box).href = n.url || '#';
      box.classList.add('bs-on');
      setTimeout(hide, 4500);
      setTimeout(show, every);
    }
    $('[data-close]', box).addEventListener('click', function () { stopped = true; hide(); });
    setTimeout(show, (parseInt(box.getAttribute('data-first'), 10) || 8) * 1000);
  });

  /* ── Combo: 3 productos, la Gyro Ball con descuento ── */
  $$('[data-bs-combo]').forEach(function (combo) {
    var off = parseFloat(combo.getAttribute('data-off')) || 0;
    var btn = $('[data-bs-combo-add]', combo);
    function calc() {
      var sub = 0, disc = 0, ok = true, items = [];
      $$('[data-bs-combo-item]', combo).forEach(function (it) {
        var sel = $('select', it);
        var opt = sel.options[sel.selectedIndex];
        var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
        var cmp = parseInt(opt.getAttribute('data-compare'), 10) || 0;
        var isGift = it.hasAttribute('data-gift');
        var final = isGift ? price * (100 - off) / 100 : price;
        sub += price; disc += price - final;
        if (opt.disabled || !opt.value) ok = false;
        items.push({ id: parseInt(opt.value, 10), quantity: 1 });
        var p = $('[data-p]', it), s = $('[data-s]', it);
        if (p) p.textContent = isGift && off >= 100 ? 'GRATIS' : money(final);
        if (s) { var o = isGift ? price : cmp; s.textContent = money(o); s.style.display = o > final ? '' : 'none'; }
        var img = $('[data-product-img]', it), src = opt.getAttribute('data-img');
        if (img && src && img.getAttribute('src') !== src) img.src = src;
        var act = $('[data-action-img]', it), asrc = opt.getAttribute('data-action');
        if (act) {
          if (asrc) { if (act.getAttribute('src') !== asrc) act.src = asrc; act.hidden = false; }
          else { act.hidden = true; it.querySelector('[data-bs-fade]').classList.remove('bs-swap'); }
        }
        var kit = $('[data-bs-kit-img="' + it.getAttribute('data-handle') + '"] img', combo), big = opt.getAttribute('data-img-big');
        if (kit && big && kit.getAttribute('src') !== big) { kit.removeAttribute('srcset'); kit.src = big; }
      });
      var e;
      if ((e = $('[data-sub]', combo))) e.textContent = money(sub);
      if ((e = $('[data-disc]', combo))) e.textContent = '-' + money(disc);
      $$('[data-tot]', combo).forEach(function (el) { el.textContent = money(sub - disc); });
      updatePay(combo, sub - disc);
      if (btn) btn.disabled = !ok;
      return items;
    }
    $$('select', combo).forEach(function (s) {
      s.addEventListener('change', function () {
        var fade = $('[data-bs-fade]', s.closest('[data-bs-combo-item]'));
        if (fade) fade.classList.remove('bs-swap');
        calc();
      });
    });
    // alterna producto / foto en acción, de a un paso por vez para que no cambien todas juntas
    if (!reduced) {
      var fades = $$('[data-bs-fade]', combo), turn = 0;
      setInterval(function () {
        if (!fades.length) return;
        var f = fades[turn % fades.length]; turn++;
        var b = $('[data-action-img]', f);
        if (b && !b.hidden) f.classList.toggle('bs-swap');
      }, 1500);
    }
    if (btn) btn.addEventListener('click', function () { addToCart(calc(), btn); });
    calc();
  });

  /* ── Reveal automático, escalonado entre hermanos ── */
  if ('IntersectionObserver' in window && !reduced) {
    var io2 = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        el.classList.add('bs-on');
        io2.unobserve(el);
        setTimeout(function () { el.style.transitionDelay = ''; }, 1400);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    $$('.bs-head,.bs-benefits--cards>*,.bs-cats>*,.bs-gal>*,.bs-cg,.bs-faq details,.bs-specs>*,.bs-rev,.bs-statement .bs-in>*,.bs-banner .bs-in>*,.bs-step,.bs-foot-cols>*,.bs-pro,.bs-reel,.bs-pay-box,.bs-checks>*').forEach(function (el) {
      if (el.classList.contains('bs-reveal') || el.closest('.bs-reveal') || el.querySelector('.bs-reveal')) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.85) return;
      var k = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = Math.min(k, 5) * 90 + 'ms';
      var kinds = [['.bs-pros--color .bs-pro', 'flip'], ['.bs-pros--claro .bs-pro', 'rise'], ['.bs-pros--numeros .bs-pro', 'line'], ['.bs-rev', 'tilt'],
        ['.bs-step', 'right'], ['.bs-faq details', 'left'], ['.bs-gal>*', 'wipe'], ['.bs-specs>*', 'wipe'], ['.bs-cg', 'wipe'], ['.bs-statement .bs-in>*', 'blur'],
        ['.bs-banner .bs-in>*', 'blur'], ['.bs-reel', 'zoom'], ['.bs-benefits--cards>*', 'zoom'], ['.bs-checks>*', 'left']];
      for (var q = 0; q < kinds.length; q++) { if (el.matches(kinds[q][0])) { el.classList.add('bs-rv-' + kinds[q][1]); break; } }
      el.classList.add('bs-reveal');
      io2.observe(el);
    });
  }

  /* ── Header: sombra al bajar ── */
  var hdr = $('.bs-header');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('bs-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Categorías: las fotos de los productos van rotando ── */
  $$('[data-bs-catrot]').forEach(function (box, n) {
    var imgs = $$('img', box), i = 0;
    if (imgs.length < 2 || reduced) return;
    setTimeout(function () {
      setInterval(function () {
        imgs[i].classList.remove('bs-on');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('bs-on');
      }, 3200);
    }, n * 700);
  });

  /* ── Header fijo: al bajar queda solo la barra del logo, el menú y el carrito ── */
  (function () {
    var group = document.getElementById('header-group') || (hdr && hdr.parentNode);
    var nav = $('.bs-nav');
    if (!group || !nav) return;
    function place() {
      var off = nav.getBoundingClientRect().top - group.getBoundingClientRect().top;
      group.style.setProperty('--bs-hd-top', (-Math.max(0, Math.round(off))) + 'px');
    }
    place();
    window.addEventListener('resize', place);
    window.addEventListener('load', place);
  })();

  /* ── Raspadita de bienvenida ── */
  (function () {
    var box = $('[data-bs-rasca]');
    if (!box) return;
    var KEY = 'bsRasca1', seen = false;
    try { seen = !!window.localStorage.getItem(KEY); } catch (e) {}
    if (window.Shopify && Shopify.designMode) return;
    var cv = $('[data-bs-rasca-canvas]', box), card = cv.parentNode, ctx = cv.getContext('2d');
    var hint = $('[data-bs-rasca-hint]', box), go = $('.bs-rasca-go', box), done = false, down = false, moves = 0;
    function paint() {
      var w = card.clientWidth, h = card.clientHeight, d = window.devicePixelRatio || 1;
      cv.width = w * d; cv.height = h * d; ctx.setTransform(d, 0, 0, d, 0, 0);
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#f9d6e0'); g.addColorStop(.5, '#fbe6ec'); g.addColorStop(1, '#f2a7bb');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(217,114,143,.16)';
      for (var i = 0; i < 140; i++) ctx.fillRect(Math.random() * w, Math.random() * h, 2, 2);
      ctx.fillStyle = '#d9728f'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '800 20px "Plus Jakarta Sans", system-ui, sans-serif';
      ctx.fillText('RASPÁ ACÁ', w / 2, h / 2 - 8);
      ctx.font = '500 12px "DM Sans", system-ui, sans-serif';
      ctx.fillText('y descubrí tu regalo', w / 2, h / 2 + 16);
    }
    function reveal() {
      if (done) return;
      done = true;
      box.classList.add('bs-won');
      if (hint) hint.hidden = true;
      if (go) go.hidden = false;
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    }
    function scratch(e) {
      if (!down || done) return;
      var r = cv.getBoundingClientRect(), p = e.touches ? e.touches[0] : e;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath(); ctx.arc(p.clientX - r.left, p.clientY - r.top, 24, 0, Math.PI * 2); ctx.fill();
      if (++moves % 8 === 0) {
        var px = ctx.getImageData(0, 0, cv.width, cv.height).data, clear = 0, total = 0;
        for (var i = 3; i < px.length; i += 64) { total++; if (px[i] === 0) clear++; }
        if (clear / total > 0.42) reveal();
      }
      if (e.cancelable) e.preventDefault();
    }
    ['mousedown', 'touchstart'].forEach(function (n) { cv.addEventListener(n, function (e) { down = true; scratch(e); }, { passive: false }); });
    ['mousemove', 'touchmove'].forEach(function (n) { cv.addEventListener(n, scratch, { passive: false }); });
    ['mouseup', 'mouseleave', 'touchend'].forEach(function (n) { window.addEventListener(n, function () { down = false; }); });
    function close() {
      box.classList.remove('bs-on');
      try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
    }
    $$('[data-bs-rasca-close]', box).forEach(function (b) { b.addEventListener('click', close); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    var code = $('[data-bs-rasca-code]', box);
    if (code) code.addEventListener('click', function () {
      var t = code.getAttribute('data-bs-rasca-code');
      if (navigator.clipboard) navigator.clipboard.writeText(t).then(function () { code.querySelector('span').textContent = 'copiado'; }, function () {});
    });
    var painted = false;
    function open() { box.classList.add('bs-on'); if (!done && !painted) { painted = true; paint(); } }
    if (seen) reveal();
    else setTimeout(open, (parseInt(box.getAttribute('data-delay'), 10) || 0) * 1000);
    $$('[data-bs-rasca-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
  })();

  /* ── Regalo sorpresa: entra solo cuando hay un producto que lo activa, y sale si ese producto se quita ── */
  (function () {
    var g = $('[data-bs-gift]');
    if (!g) return;
    var id = parseInt(g.getAttribute('data-id'), 10), need = g.getAttribute('data-need') === 'true';
    var key = g.getAttribute('data-key'), qty = parseInt(g.getAttribute('data-qty'), 10) || 0, ok = g.getAttribute('data-ok') === 'true';
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    }
    var tried = false;
    try { tried = window.sessionStorage.getItem('bsGiftTry') === '1'; } catch (e) {}
    function done() { try { window.sessionStorage.removeItem('bsGiftTry'); } catch (e) {} window.location.reload(); }
    function fail() { try { window.sessionStorage.setItem('bsGiftTry', '1'); } catch (e) {} }
    if (need && !key && id && ok && !tried) {
      post(cartAddUrl, { items: [{ id: id, quantity: 1 }] }).then(done, fail);
    } else if (!need && key) {
      post((cfg.cartChangeUrl || '/cart/change') + '.js', { id: key, quantity: 0 }).then(done, fail);
    } else if (need && key && qty > 1) {
      post((cfg.cartChangeUrl || '/cart/change') + '.js', { id: key, quantity: 1 }).then(done, fail);
    }
  })();

  /* ── Promo con cuenta regresiva hasta la fecha de fin configurada (hora de Argentina) ── */
  $$('[data-bs-promo]').forEach(function (el) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/.exec(el.getAttribute('data-end') || '');
    if (!m) return;
    var end = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] + 3, +m[5]);
    var h = $('[data-h]', el), mi = $('[data-m]', el), se = $('[data-s]', el), timer;
    function two(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
      el.hidden = false;
      h.textContent = two(Math.floor(left / 3600)); mi.textContent = two(Math.floor(left % 3600 / 60)); se.textContent = two(left % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  });
})();
